import {
  enumBoxWidthMode,
  enumCellContentType,
  enumChartRenderOrder,
  enumDropType,
  enumElementLayer
} from "../constants";
import { QAltBackground } from "./QAltBackground";
import { QPanel } from "./QPanel";
import { QPoint } from "./QPoint";

export class QBasePanel extends QPanel {
  constructor() {
    super();
    this.fToolMode = "";
    this.fBackgroundPanel = null;
    this.fAltBackground = null;
  }

  InitBasePanel(backgroundPanel) {
    this.SetFillColor("#FFFFFF");
    this.fBackgroundPanel = backgroundPanel;
    this.SetNeedsCustomResize(true);

    this.AddZPlane(enumChartRenderOrder.underlay);
    this.AddZPlane(enumChartRenderOrder.connectingLine);
    this.AddZPlane(enumChartRenderOrder.chartBox);
    this.AddZPlane(enumChartRenderOrder.groups);
    this.AddZPlane(enumChartRenderOrder.textBox);
    this.AddZPlane(enumChartRenderOrder.overlay);
    //	this.AddZPlane(enumChartRenderOrder.activeBox);
  }

  UpdateSelectedProperty(parameter, theProperty) {
    // Override this
  }

  SurveySelectedProperty(theProperty) {
    // Override this
  }

  PanelToolModeChanged() {
    // Override this
  }

  SetHoverHighlightEnabled(enabled) {
    // Override this
  }

  SetPanelToolMode(toolMode) {
    //console.log("SetPanelToolMode:", toolMode);
    this.fToolMode = toolMode;
    this.PanelToolModeChanged();
  }

  GetPanelToolMode() {
    return this.fToolMode;
  }

  GetSelectedBoxes(includeTextBoxes) {
    return null;
  }

  DeleteSelection(ctrlKey) {
    return null;
  }

  GetDropType() {
    return enumDropType.none;
  }

  // Used by ribbons to determine if the panel permits certain menu options (e.g. Save/Undo/etc)
  IsMainPanel() {
    return false;
  }

  GetPreviewMode() {
    return false;
  }

  ResizeCanvasCenter(priorScaleFactor) {}

  SupportsZoom() {
    return false;
  }

  SetDocDirty() {}

  DynamicResizeComplete(srcElement) {}

  GetFirstSelectedBox(includeTextBox) {
    return null;
  }

  CustomShiftSelect(targetElement) {
    return false;
  }

  //=================================================================================
  // Clipboard support
  // Override to support copy/paste of custom objects
  CanCustomCopy() {
    return false;
  }

  CanCustomCut() {
    return false;
  }

  CanCustomPaste() {
    return false;
  }

  DoCustomCopy(clipboard) {
    return null;
  }

  DoCustomPaste(clipboard) {}

  //=================================================================================
  //Resizing Routines
  DoResizeCanvas() {
    var scaleFactor = this.GetScaleFactor();
    var canvasWidth = this.fCanvasSizeX;
    var canvasHeight = this.fCanvasSizeY;
    var scaledCanvasWidth = Math.round(canvasWidth * scaleFactor);
    var scaledCanvasHeight = Math.round(canvasHeight * scaleFactor);

    var availableWidth = this.fBackgroundPanel.GetWidth(); //PlusBorder();
    var availableHeight = this.fBackgroundPanel.GetHeight();

    var portWidth = Math.min(availableWidth, scaledCanvasWidth);
    var portHeight = Math.min(availableHeight, scaledCanvasHeight);

    var p = this.CanvasOffset(availableWidth, availableHeight, portWidth, portHeight);
    var portX = p.fX;
    var portY = p.fY;

    this.PositionPanel(portX, portY);
    this.SizePanelAndPort(canvasWidth, canvasHeight, portWidth, portHeight);
  }

  CanvasOffset(availableWidth, availableHeight, portWidth, portHeight) {
    var p = new QPoint();

    var portPosX = this.fBackgroundPanel.fHorzOffset;
    var portPosY = this.fBackgroundPanel.fVertOffset;

    if (portWidth < availableWidth)
      portPosX = Math.round(portPosX + (availableWidth - portWidth) / 2);

    if (portHeight < availableHeight)
      portPosY = Math.round(portPosY + (availableHeight - portHeight) / 2);

    this.SetPanelMode(this.fWSMgr.GetDefaultPanelMode());

    p.InitPoint(portPosX, portPosY);
    return p;
  }

  UpdatePanOffset(priorPanX, priorPanY, priorPortWidth, priorPortHeight, priorScaleFactor) {
    var scaleFactor = this.GetScaleFactor();
    var portHeight = this.fPortHeight;
    var portWidth = this.fPortWidth;
    var canvasWidth = this.fCanvasSizeX;
    var canvasHeight = this.fCanvasSizeY;

    var unscaledPriorPortWidth = Math.round(priorPortWidth / priorScaleFactor);
    var unscaledPriorPortHeight = Math.round(priorPortHeight / priorScaleFactor);

    var priorCenterX = priorPanX + Math.round(unscaledPriorPortWidth / 2);
    var priorCenterY = priorPanY + Math.round(unscaledPriorPortHeight / 2);

    var unscaledPortWidth = Math.round(portWidth / scaleFactor);
    var unscaledPortHeight = Math.round(portHeight / scaleFactor);
    var newCenterX = Math.round(unscaledPortWidth / 2);
    var newCenterY = Math.round(unscaledPortHeight / 2);

    var maxPanX = canvasWidth - unscaledPortWidth;
    var maxPanY = canvasHeight - unscaledPortHeight;
    var panX = Math.min(priorCenterX - newCenterX, maxPanX);
    var panY = Math.min(priorCenterY - newCenterY, maxPanY);

    if (panX < 0) panX = 0;

    if (panY < 0) panY = 0;

    this.SetPanX(panX);
    this.SetPanY(panY);
  }

  // Background effects
  CreateBackgroundElements() {
    if (!this.fAltBackground) {
      this.fAltBackground = new QAltBackground();
      this.fAltBackground.InitBackground(this);
      this.fAltBackground.SetLayer(enumElementLayer.master);
      this.PushElement(this.fAltBackground);
    }
  }

  RenderMasterPage() {
    this.RenderAllZPlanes(enumElementLayer.master);
  }

  PositionAltBackground() {
    if (this.fAltBackground == null) this.CreateBackgroundElements();

    var canvasWidth = this.fCanvasSizeX ?? this.GetWidth();
    var canvasHeight = this.fCanvasSizeY ?? this.GetHeight();
    this.fAltBackground.PositionElement(0, 0);
    this.fAltBackground.SizeElement(canvasWidth, canvasHeight);
  }

  DoGetDeleteColumns(layout, layoutCells) {
    var numCols = layout.GetNumCols();
    var maxCol = numCols + 1;
    var deleteCols = [];
    var numElements = layoutCells.length;
    for (var i = 0; i < numElements; i++) {
      var theElement = layoutCells[i];
      if (theElement.IsSelected()) {
        var cellDesc = theElement.GetCellDesc();
        var curColIndex = cellDesc.GetColIndex();

        if (curColIndex > 0 && curColIndex < maxCol) {
          var index = deleteCols.indexOf(curColIndex);
          if (index == -1) deleteCols.push(curColIndex);
        }
      }
    }
    // Sort descending
    deleteCols.sort(function (a, b) {
      return b - a;
    });

    var numDelCols = deleteCols.length;
    if (numDelCols >= numCols || numDelCols == 0) return null;
    else return deleteCols;
  }

  DoGetDeleteRows(layout, layoutCells) {
    var deleteRows = [];
    var numRows = layout.GetNumRows();
    var maxRows = numRows + 1;
    var numElements = layoutCells.length;
    for (var i = 0; i < numElements; i++) {
      var theElement = layoutCells[i];
      if (theElement.IsSelected()) {
        var cellDesc = theElement.GetCellDesc();
        var curRowIndex = cellDesc.GetRowIndex();

        if (curRowIndex > -1 && curRowIndex < maxRows) {
          var index = deleteRows.indexOf(curRowIndex);
          if (index == -1) deleteRows.push(curRowIndex);
        }
      }
    }

    // Sort descending
    deleteRows.sort(function (a, b) {
      return b - a;
    });

    var numDelRows = deleteRows.length;
    if (numDelRows > numRows || numDelRows == 0) return null;
    else return deleteRows;
  }

  DoGetOuterSelectionColumn(layout, layoutCells, leftMost = false) {
    var activeSelection = false;
    var colIndex = 0;
    var maxCol = layout.GetNumCols() + 1;
    if (leftMost) colIndex = maxCol;

    var numElements = layoutCells.length;
    for (var i = 0; i < numElements; i++) {
      var theElement = layoutCells[i];
      if (theElement.IsSelected()) {
        activeSelection = true;
        var cellDesc = theElement.GetCellDesc();
        var curColIndex = cellDesc.GetColIndex();

        if (leftMost) {
          if (curColIndex < colIndex) colIndex = curColIndex;
        } else {
          if (theElement.IsMergedCell()) {
            colIndex = curColIndex + cellDesc.GetMergeX();
          }
          if (curColIndex > colIndex) colIndex = curColIndex;
        }
      }
    }

    if (!activeSelection) colIndex = -1;
    else if (leftMost && colIndex == 0) colIndex = -1;
    else if (!leftMost && colIndex == maxCol) colIndex = -1;

    return colIndex;
  }

  DoGetOuterSelectionRow(layout, layoutCells, topMost = false) {
    var activeSelection = false;
    var rowIndex = 0;
    var maxRow = layout.GetNumRows() + 1;
    if (topMost) rowIndex = maxRow;
    var numElements = layoutCells.length;
    for (var i = 0; i < numElements; i++) {
      var theElement = layoutCells[i];
      if (theElement.IsSelected()) {
        activeSelection = true;
        var cellDesc = theElement.GetCellDesc();
        var curRowIndex = cellDesc.GetRowIndex();

        if (topMost) {
          if (curRowIndex < rowIndex) rowIndex = curRowIndex;
        } else {
          if (theElement.IsMergedCell()) {
            rowIndex = curRowIndex + cellDesc.GetMergeY();
          }
          if (curRowIndex > rowIndex) rowIndex = curRowIndex;
        }
      }
    }

    if (!activeSelection) rowIndex = -1;
    else if (topMost && rowIndex == 0) rowIndex = -1;
    else if (!topMost && rowIndex == maxRow) rowIndex = -1;

    return rowIndex;
  }

  DoGetSelectedCellDescs(layoutCells) {
    var cellList = [];
    var numElements = layoutCells.length;
    for (var i = 0; i < numElements; i++) {
      var theElement = layoutCells[i];
      if (theElement.IsSelected()) {
        var cellDesc = theElement.GetCellDesc();
        if (!cellDesc.IsGutterCell()) cellList.push(cellDesc);
      }
    }
    return cellList;
  }

  DoSelectCell(layoutCells, colIndex, rowIndex) {
    var numElements = layoutCells.length;
    for (var i = 0; i < numElements; i++) {
      var theElement = layoutCells[i];
      if (this.IncludeElementInSelection(theElement)) {
        var cellDesc = theElement.GetCellDesc();
        var curRowIndex = cellDesc.GetRowIndex();
        var curColIndex = cellDesc.GetColIndex();

        if (colIndex == curColIndex && rowIndex == curRowIndex) {
          this.DoSelectElement(theElement, true);
          return true;
        }
      }
    }
  }

  ApplyRowInsert(layout, insertAbove) {
    var y = this.GetOuterSelectionRow(insertAbove);
    if (y == null) return;
    var newCells = layout.InsertRow(y, insertAbove);
    newCells.forEach(x => x.SetCellContentType(enumCellContentType.FreeText));
  }

  GetOuterSelectionRow() {
    // override'
    return null;
  }

  ApplyColumnInsert(layout, insertLeft) {
    var x = this.GetOuterSelectionColumn(insertLeft);
    if (x == null) return;
    layout.SetWidthSizingMode(enumBoxWidthMode.fixedwidth);
    var newCells = layout.InsertColumn(x, insertLeft);
    newCells.forEach(x => x.SetCellContentType(enumCellContentType.FreeText));
  }

  GetOuterSelectionColumn() {
    // override'
    return null;
  }

  ApplyRowDelete(layout) {
    var delRows = this.GetDeleteRows();
    if (delRows == null) return;

    var rowsToDelete = delRows.length;

    var postSelectRow = this.GetOuterSelectionRow(false);
    if (postSelectRow == -1) postSelectRow = 1;
    else postSelectRow = postSelectRow + 1 - rowsToDelete;

    for (var i = 0; i < rowsToDelete; i++) layout.DeleteRow(delRows[i]);

    // Maybe here - Content Changed?

    var layoutRows = layout.GetNumRows();
    if (postSelectRow > layoutRows) postSelectRow = layoutRows;

    this.SelectCell(1, postSelectRow);

    return postSelectRow;
  }

  GetDeleteRows() {
    // override this
    return null;
  }

  SelectCell() {
    // override this
    return null;
  }

  ApplyColumnDelete(layout) {
    var delCols = this.GetDeleteColumns();
    var colsToDelete = delCols.length;
    if (delCols == null) return;

    var postSelectCol = this.GetOuterSelectionColumn(false);
    if (postSelectCol == -1) postSelectCol = 1;
    else postSelectCol = postSelectCol + 1 - colsToDelete;

    for (var i = 0; i < colsToDelete; i++) layout.DeleteColumn(delCols[i]);

    var layoutCols = layout.GetNumCols();
    if (postSelectCol > layoutCols) postSelectCol = layoutCols;

    return this.SelectCell(postSelectCol, 1);
  }

  GetDeleteColumns() {
    // override this
    return null;
  }

  ApplyMergeCells() {
    var cellList = this.GetSelectedCellDescs();

    var n = cellList.length;
    var mCount = 0;
    for (var i = 0; i < n; i++) {
      var c = cellList[i];
      if (c.IsMergedCell()) mCount++;
    }

    if (mCount > 0) return;

    var theLayout = this.GetLayout();
    theLayout.DoMergeCells(cellList);
  }

  GetLayout() {
    return null;
  }

  GetSelectedCellDescs() {
    return null;
  }

  ApplyUnMergeCells() {
    var cellList = this.GetSelectedCellDescs();
    var theLayout = this.GetLayout();
    theLayout.DoUnmergeCells(cellList);
  }

  GetChartBox() {
    return null;
  }
}
